import React from 'react';
import styles from './compraTerceiroInputs.module.scss';
import { BrInput } from '@govbr-ds/react-components';
import { formatStringToBR } from '../../../../../../../../../utils/formatNumber';

interface CompraTerceiroInputsProps {
  quantidade: string;
  setQuantidade: React.Dispatch<React.SetStateAction<string>>;
  valorTotal: string;
  setValorTotal: React.Dispatch<React.SetStateAction<string>>;
  isReadOnly?: boolean;
}

const CompraTerceiroInputs = ({
  quantidade,
  setQuantidade,
  valorTotal,
  setValorTotal,
  isReadOnly = false,
}: CompraTerceiroInputsProps) => {
  return (
    <div className={styles.comprasTerceiroContainer}>
      <span className={styles.label}>Compras de terceiros</span>
      <div className={styles.inputsContainer}>
        <div className={styles.input}>
          <span className={styles.label}>Quantidade a abater da aquisição de terceiros</span>
          {!isReadOnly ? (
            <BrInput
              autoComplete='off'
              required
              onChange={(e) => setQuantidade(e.target.value.replace(',', '.'))}
              value={quantidade}
              numeric={{
                decimalScale: 2,
                fixedDecimalScale: false,
              }}
            />
          ) : (
            formatStringToBR(quantidade)
          )}
        </div>
        <div className={styles.input}>
          <span className={styles.label}>Valor total a abater da aquisição de terceiros (R$)</span>
          {!isReadOnly ? (
            <BrInput
              autoComplete='off'
              numeric={{
                prefix: 'R$ ',
                thousandSeparator: '.',
                decimalScale: 2,
                fixedDecimalScale: false,
              }}
              required
              onChange={(e) => setValorTotal(e.target.value)}
              value={valorTotal}
            />
          ) : (
            valorTotal
          )}
        </div>
      </div>
    </div>
  );
};

export default CompraTerceiroInputs;
